var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8651 11.8803V6.66989H9.21847C9.41051 6.66989 9.57183 6.83138 9.57183 7.02688V10.3418C9.57183 11.1918 10.2478 11.8803 11.0851 11.8803C11.9224 11.8803 12.5984 11.1918 12.5984 10.3418V3.96691C12.5984 3.63542 12.4602 3.32942 12.2451 3.11692L11.0083 1.86744C10.7855 1.63794 10.4245 1.63794 10.2017 1.86744C9.97896 2.09693 9.97896 2.46243 10.2017 2.69193L11.0006 3.50792L10.4091 4.13691C10.2171 4.34091 10.2171 4.66391 10.4091 4.8679C10.5013 4.9699 10.6319 5.0209 10.7625 5.0209H11.4308V10.3503C11.4308 10.5458 11.2772 10.7073 11.0774 10.7073C10.8854 10.7073 10.7241 10.5458 10.7241 10.3503V7.03538C10.7241 6.18539 10.0481 5.4969 9.21078 5.4969H8.8651V2.65793C8.8651 2.13093 8.45029 1.71444 7.92793 1.71444H3.03465C2.51997 1.71444 2.09748 2.13943 2.09748 2.65793V11.8803H1.98225C1.65962 11.8803 1.39844 12.1438 1.39844 12.4753C1.39844 12.8068 1.65962 13.0703 1.98225 13.0703H8.98033C9.30296 13.0703 9.56414 12.8068 9.56414 12.4753C9.56414 12.1438 9.30296 11.8803 8.98033 11.8803H8.8651ZM3.77978 2.88743H7.1828C7.46702 2.88743 7.69748 3.11692 7.69748 3.40592V5.91339C7.69748 6.20239 7.46702 6.43189 7.1828 6.43189H3.77978C3.49556 6.43189 3.2651 6.20239 3.2651 5.91339V3.40592C3.2651 3.11692 3.49556 2.88743 3.77978 2.88743Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.d5f74448c2e8dd389feedec696584edc.svg";
export { ForwardRef as ReactComponent };